import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { KindService } from 'app/services/models/kind.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { BlockUI, NgBlockUI } from 'ng-block-ui';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class OrderListComponent implements OnInit {
  @BlockUI('section-block') blockUI: NgBlockUI;
  rows: any;
  public pageBasic = 1;
  public selectedSize = 5;
  public basicSelectedOption: number = 5;
  public searchValue = '';
  totalCount: Number = 0;
  kindId: number = null;
  public ColumnMode = ColumnMode;


  constructor(
    private transactionService: TransactionService,
    private kindService: KindService,
    private router: Router) { }

  async ngOnInit() {
    await this.kindByName();
  }

  async kindByName() {
    const data = await this.kindService.getByName('sipariş');
    console.log(data);
    if (data) {
      this.kindId = data.id;
      await this.getAllOder(0, 5, '', this.kindId);
    }
  }

  async getAllOder(page, size, search, kindId) {
    const data = await this.transactionService.getAllOfferTransaction(page, size, search, kindId);
    console.log(data);
    this.totalCount = data.totalCount;
    this.rows = data.transactionManagements;
  }

  async onPageChange(pageNumber: number) {
    await this.getAllOder(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId);
  }

  async onOptionChange() {
    this.selectedSize = Number(this.basicSelectedOption)
    await this.getAllOder(this.pageBasic - 1, this.selectedSize, this.searchValue, this.kindId);
  }

  onActivate(event: any) {
    if (event.type === 'click' && event.row) {

      this.router.navigate([`/admin/order-detail/${event.row.id}`]);
    }
  }

  getStatusText(status: number): string {
    switch (status) {
      case 1:
        return 'Sipariş Oluşturuldu';
      case 2:
        return 'İptal Edildi';
      case 3:
        return 'Onaylandı';
      case 4:
        return 'Reddedildi';
      default:
        return 'Bilinmiyor'; // veya uygun bir varsayılan metin
    }
  }

  getStatusClass(status: number): string {
    switch (status) {
      case 1:
        return 'badge badge-glow badge-info';    // Info class for status 1
      case 2:
        return 'badge badge-glow badge-danger';  // Danger class for status 2
      case 3:
        return 'badge badge-glow badge-success'; // Success class for status 3
      case 4:
        return 'badge badge-glow badge-warning'; // Warning class for status 4
      default:
        return 'badge badge-glow badge-secondary'; // Secondary class for unknown status
    }
  }
}